// extracted by mini-css-extract-plugin
export default {"container":"BA1cq","item":"wKeEL","label":"EQzL5","links":"_7qoXl","linkWrapper":"_8cfko"};